import { useCallback, useEffect } from 'react';
import { t } from 'i18next';
import { POST_MESSAGES } from '../constants/PostMessages';
import { useSelectedTradingCardsStore } from '../store/useSelectedTradingCardsStore';
import { useSuccessPhotoCardToast } from '../../template/edit-collected-photo-cards/hooks/useSuccessPhotoCardToast';
import throttle from 'lodash/throttle';
import { QUERY_KEYS } from '../constants/QueryKeys';
import { useQueryClient } from 'react-query';

export const useMessageHandler = () => {
  const clearPhotoCards = useSelectedTradingCardsStore((state) => state.clearPhotoCards);
  const showSuccessToast = useSuccessPhotoCardToast();
  const queryClient = useQueryClient();

  const invalidateQueries = useCallback(() => {
    queryClient.invalidateQueries(QUERY_KEYS.tradingPhotoCardsAll('sale'));
    queryClient.invalidateQueries(QUERY_KEYS.tradingPhotoCardsAll('exchange'));
  }, [queryClient]);

  useEffect(() => {
    const handleMessage = throttle((event) => {
      if (event.origin !== window.location.origin) return;
      const { type } = event.data || {};
      if (type === POST_MESSAGES.clearSelectedTradingPhotoCards) {
        clearPhotoCards();
      }
      if (type === POST_MESSAGES.completedNewTradingPhotoCards) {
        invalidateQueries();
        clearPhotoCards();
        showSuccessToast('bottom', t('NewTradingPhotoCards.completedMessage') as string);
      }
    }, 1000);

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
      handleMessage.cancel();
    };
  }, [clearPhotoCards, invalidateQueries, showSuccessToast]);
};
